module.exports = __webpack_public_path__ + "img/carbon_warning-square.3dd2409f.svg";